/* eslint-disable no-nested-ternary */
import camelCase from 'lodash/camelCase';

import { useTranslation } from 'next-i18next';

import type { Owner } from 'src/types/__generated__/graphql';
import { useCompanyActivityToDisplay } from 'src/hooks/useActivityToDisplay';

const useOwnerSubDisplayName = (owner?: Owner) => {
    const { t } = useTranslation(['common', 'company']);
    const getCompanyActivityToDisplay = useCompanyActivityToDisplay();

    if (owner?.user) {
        return owner.user.customActivity
            ? owner.user.customActivity
            : owner.user.activity?.labelKey
              ? t(`common:activities.${camelCase(owner.user.activity.labelKey)}`)
              : t('common:individual');
    }
    if (owner?.company) {
        return getCompanyActivityToDisplay(owner.company);
    }
    return '';
};

export default useOwnerSubDisplayName;
